import { render, staticRenderFns } from "./SpecialtiesDetails.vue?vue&type=template&id=3644b377"
import script from "./SpecialtiesDetails.vue?vue&type=script&lang=js"
export * from "./SpecialtiesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports